var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCustomerService17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 15.1667V9.50001C1 7.24567 2.00921 5.08366 3.80561 3.4896C5.602 1.89553 8.03845 1 10.5789 1C13.1194 1 15.5559 1.89553 17.3523 3.4896C19.1487 5.08366 20.1579 7.24567 20.1579 9.50001V15.1667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.1579 16.1111C20.1579 16.6121 19.9336 17.0925 19.5344 17.4467C19.1352 17.801 18.5938 18 18.0292 18H16.9649C16.4003 18 15.8589 17.801 15.4597 17.4467C15.0605 17.0925 14.8362 16.6121 14.8362 16.1111V13.2778C14.8362 12.7768 15.0605 12.2963 15.4597 11.9421C15.8589 11.5879 16.4003 11.3889 16.9649 11.3889H20.1579V16.1111ZM1 16.1111C1 16.6121 1.22427 17.0925 1.62347 17.4467C2.02267 17.801 2.5641 18 3.12865 18H4.19298C4.75753 18 5.29896 17.801 5.69816 17.4467C6.09736 17.0925 6.32163 16.6121 6.32163 16.1111V13.2778C6.32163 12.7768 6.09736 12.2963 5.69816 11.9421C5.29896 11.5879 4.75753 11.3889 4.19298 11.3889H1V16.1111Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerService17);
export default __webpack_public_path__ + "static/media/icon_customer_service_17.ad451f3a1f40cbb430b9d37f06880759.svg";
export { ForwardRef as ReactComponent };